import React from "react";
import { Button } from "../../../ui";
import { Trash, X } from "react-bootstrap-icons";
import styles from "./style.module.scss";

const ConfirmPopup = ({ show, title, message, onConfirm, onCancel, loading }) => {
  if (!show) return null;

  return (
    <div className={styles.popupContainer}>
      <div className={styles.popupInnerBox}>
        <div className={styles.closePopup}>
          <X size={24} onClick={onCancel} />
        </div>
        
        <div className={styles.iconContainer}>
          <Trash size={60} />
        </div>
        
        <h2>{title || "Confirm Action"}</h2>
        <p className={styles.message}>{message || "Are you sure you want to proceed?"}</p>
        
        <div className={styles.buttonContainer}>
          <Button
            label="Cancel"
            secondary
            onClick={onCancel}
            disabled={loading}
            style={{ minWidth: "120px" }}
          />
          <Button
            label={loading ? "Processing..." : "Confirm"}
            primary
            onClick={onConfirm}
            disabled={loading}
            style={{ minWidth: "120px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup; 